/* Hoggle — price negotiation bot. Upload to Shopify theme → Assets as hoggle.js */
(function(){
  /* Walk-away status row CSS — injected once, scoped to .hoggle-status.
     Lives here (not hoggle.css) so the visual lands the moment the
     updated JS deploys, no separate CSS push required. */
  if (!document.getElementById('hoggle-walkaway-css')){
    var st = document.createElement('style');
    st.id = 'hoggle-walkaway-css';
    st.textContent =
      /* walk-away status */
      '.hoggle-status{display:flex;align-items:center;justify-content:space-between;' +
        'gap:10px;margin:14px 0 4px;padding:10px 14px;border-radius:12px;' +
        'background:#fef3f2;border:1px solid #fecaca;' +
        'animation:hoggleStatusIn .3s ease both;}' +
      '.hoggle-status__line{display:flex;align-items:center;gap:8px;font-size:12.5px;' +
        'color:#991b1b;font-weight:600;letter-spacing:.005em;}' +
      '.hoggle-status__dot{width:8px;height:8px;border-radius:50%;background:#9ca3af;' +
        'flex-shrink:0;box-shadow:0 0 0 3px rgba(156,163,175,.25);}' +
      '.hoggle-status__btn{background:#0a0a0a;color:#fff;border:0;border-radius:999px;' +
        'padding:6px 14px;font:600 12px "Inter",-apple-system,sans-serif;cursor:pointer;' +
        'transition:transform .15s,background .15s;}' +
      '.hoggle-status__btn:hover{background:#222;transform:translateY(-1px);}' +
      '@keyframes hoggleStatusIn{from{opacity:0;transform:translateY(6px);}to{opacity:1;transform:none;}}' +

      /* live deal card — checkout button + countdown */
      '.hoggle-deal-card--live{display:flex;flex-direction:column;align-items:center;gap:10px;' +
        'padding:18px 16px 14px;}' +
      '.hoggle-deal-card--live .hoggle-deal-card__cta{' +
        'display:inline-flex;align-items:center;justify-content:center;gap:8px;' +
        'width:100%;padding:13px 18px;border:0;border-radius:12px;' +
        'background:#0a0a0a;color:#fff;cursor:pointer;' +
        'font:700 14px "Inter",-apple-system,sans-serif;letter-spacing:-.005em;' +
        'transition:background .15s,transform .15s,opacity .15s;}' +
      '.hoggle-deal-card--live .hoggle-deal-card__cta:hover:not(:disabled):not(.is-disabled){' +
        'background:#1a1a1a;transform:translateY(-1px);}' +
      '.hoggle-deal-card--live .hoggle-deal-card__cta:disabled,' +
      '.hoggle-deal-card--live .hoggle-deal-card__cta.is-disabled{' +
        'opacity:.45;cursor:not-allowed;background:#4b4b4b;}' +
      '.hoggle-deal-card__timer{display:inline-flex;align-items:center;gap:6px;' +
        'font:600 12px "Inter",sans-serif;color:#525252;letter-spacing:.005em;}' +
      '.hoggle-deal-card__timer svg{color:#9ca3af;flex-shrink:0;}' +
      '.hoggle-deal-card__timer strong{font-weight:700;color:#0a0a0a;font-variant-numeric:tabular-nums;}' +
      '.hoggle-deal-card__timer.is-expired,.hoggle-deal-card__timer.is-expired strong{color:#991b1b;}' +
      '.hoggle-deal-card__note{font:500 11px "Inter",sans-serif;color:#737373;text-align:center;line-height:1.4;}' +
      '.hoggle-deal-card--urgent .hoggle-deal-card__timer strong{color:#dc2626;animation:hoggleTickPulse 1s ease-in-out infinite;}' +
      '@keyframes hoggleTickPulse{0%,100%{opacity:1;}50%{opacity:.45;}}';
    document.head.appendChild(st);
  }

  function init(root){
    if(!root || root.dataset.hoggleBound === '1') return;
    root.dataset.hoggleBound = '1';

    // --- State ---------------------------------------------------------
    var currentCents = parseInt(root.dataset.currentPriceCents, 10) || 0;

    /* Resolve the negotiation floor from the obfuscated DOM attrs.
       The page renders `data-tx = floor + salt` and `data-rid = salt`,
       so `floor = tx - rid`. Names look like generic tracking IDs to
       confuse MAP scrapers regexing for prices. See hoggle-modal.liquid
       for the encoding side. */
    function resolveFloor(){
      var tx  = parseInt(root.dataset.tx,  10) || 0;
      var rid = parseInt(root.dataset.rid, 10) || 0;
      return tx > rid ? tx - rid : 0;
    }
    var floorCents = resolveFloor();
    // No metafield set? Floor = current price. Hoggle will banter but never discount.
    if(floorCents <= 0 || floorCents >= currentCents){
      floorCents = currentCents;
    }
    var botOfferCents = currentCents;
    var round = 0;
    var maxRounds = 5;
    var lowballStreak = 0;     // consecutive sub-50% offers
    var maxLowballs = 5;       // walk away after this many in a row
    var accepted = false;
    var working = false;

    function fmt(cents){
      var n = (cents/100);
      try{
        return new Intl.NumberFormat(undefined, { style:'currency', currency: root.dataset.currency || 'USD' }).format(n);
      }catch(e){ return '$' + n.toFixed(2); }
    }

    var thread = root.querySelector('[data-hoggle-thread]');
    var form   = root.querySelector('[data-hoggle-form]');
    var input  = root.querySelector('[data-hoggle-input]');
    var sendBtn= root.querySelector('[data-hoggle-send]');
    var quick  = root.querySelector('[data-hoggle-quick]');
    var thumb  = root.querySelector('[data-hoggle-thumb]');
    var listed = root.querySelector('[data-hoggle-listed]');

    if(root.dataset.productImage && thumb) thumb.src = root.dataset.productImage;
    if(listed) listed.textContent = fmt(currentCents);

    var OPEN_LINES = [
      "Hi, I'm Hoggle. I've got a little wiggle room on this one — what's your number?",
      "Alright, let's hear it. What do you want to pay? (be nice to me)",
      "My manager said I can negotiate on this one. Throw out an offer.",
      "Okay, deal-hunter — what are you thinking?",
      "Hey there. I'm authorized to come down a bit. What's fair?",
      "Welcome. Let's see if we can make a deal. Your number?",
      "Hi. I'm Hoggle, and yes, I can flex on price. What's the move?",
      "Alright, you found me. Tell me what you want to pay.",
      "Pull up a chair. What number works for you?",
      "Hi friend. The price is the price unless you talk to me. Go.",
      "Beach AI sent me. I've got a bit of slack — what's your offer?",
      "Hi. I'm a bargaining bot, and you look like a bargain hunter. Hit me.",
      "Let's negotiate. What's your starting offer?",
      "Heya. I have approval to move on this. What number?"
    ];
    var LOWBALL = [
      "Oof. You're trying to hurt me. That's way below what I can do.",
      "Ha. My boss would put me in a box for that. Try again — higher.",
      "I admire the confidence. But no. Come closer to list.",
      "That's not an offer, that's a prank. Serious number?",
      "I think your finger slipped. Add a digit?",
      "If I said yes to that, I'd be unemployed by sundown.",
      "That's a brave little number. Brave but doomed.",
      "Wow. Bold. No.",
      "I'd love to. I can't. Come up.",
      "That's a number from a yard sale, not a TV. Try again.",
      "Hard pass. Make it real.",
      "You and I both know that's not it. What's the actual offer?",
      "I'm choosing not to be insulted. Try again.",
      "Even Hoggles have feelings. Higher please.",
      "That offer would close the warehouse. No.",
      "Generous of you, to me, you mean."
    ];
    var TOO_LOW_SOFT = [
      "You're circling something real, but not yet. I can do %OFFER%.",
      "Getting warmer. My best right now is %OFFER%.",
      "Closer. How about I meet you at %OFFER%?",
      "I can see you're serious. I'll come down to %OFFER%.",
      "We're in the same neighborhood now. %OFFER%?",
      "You're not crazy — you're just early. Try %OFFER%.",
      "I respect the offer. I'll counter at %OFFER%.",
      "Closer than before. I can swing %OFFER%.",
      "Almost there. What about %OFFER%?",
      "We can work with that energy. I'll do %OFFER%.",
      "Let's split the difference somewhere — I'm at %OFFER%.",
      "I see what you're doing. Counter: %OFFER%.",
      "Now we're talking. %OFFER% from my side."
    ];
    var COUNTER = [
      "Best I can do is %OFFER%. I'm cutting into margin here.",
      "I'll take it to %OFFER%. That's a real one.",
      "Tell you what — %OFFER%. Shake on it?",
      "%OFFER%. Final-ish. I'd lose my job lower.",
      "Look, %OFFER%. That's the move.",
      "%OFFER% and we both walk away happy.",
      "I can do %OFFER%. Don't make me beg.",
      "%OFFER%. That's a friends-and-family number.",
      "Meet me at %OFFER%? Last counter from this round.",
      "%OFFER% — that's the kind of deal I tell my mom about.",
      "Final-ish offer: %OFFER%. Let's close it.",
      "%OFFER%. Below that I'm trading vibes for cash."
    ];
    var ACCEPT = [
      "Alright, you drive a hard bargain. %OFFER% — it's yours.",
      "Fine, fine, you win. %OFFER%, sold.",
      "Okay, %OFFER%. Don't tell my manager.",
      "You got me. %OFFER%. Let's wrap this up.",
      "Deal. %OFFER%. Hit checkout before I change my mind.",
      "Sold. %OFFER%. Pleasure doing business.",
      "%OFFER% it is. You earned this one.",
      "I respect the negotiation. %OFFER% — yours.",
      "Okay, twist my arm. %OFFER%, done.",
      "Alright, %OFFER%. Going once, going twice — sold to you."
    ];
    var FLOOR_HIT = [
      "That's it. %OFFER% is the absolute bottom — take it or leave it.",
      "%OFFER%. I literally cannot go lower. Deal?",
      "This is the floor: %OFFER%. No more wiggle.",
      "%OFFER%. Below that and I'm working for free.",
      "%OFFER%. End of the road, friend.",
      "I've shown my hand: %OFFER%. That's the bottom.",
      "Final final: %OFFER%. Yes or no?",
      "Last stop, %OFFER%. Doors closing.",
      "%OFFER% is the line. I literally can't cross it.",
      "%OFFER%. That's bedrock."
    ];
    var HARD_LOWBALL = [
      "Okay, I'm starting to think you're not serious. One more like that and I'm out.",
      "I'm losing patience here, friend. Real number this time?",
      "Look — we both know what this is. Last warning before I close the chat.",
      "Three of those in a row. I'm one keystroke from walking.",
      "I've been polite. Don't make me change tone. Real offer?",
      "You're testing me. Don't. Make a real number.",
      "Final-final patience: give me an actual offer.",
      "I'm not a piñata. Stop swinging. Real number?"
    ];
    var WALK_AWAY = [
      "Look, we're not landing this. Come back another day.",
      "I think we're too far apart. No hard feelings.",
      "I've given you my best. The door's always open.",
      "We tried. Maybe next time. Don't be a stranger.",
      "I'm tapping out. The price is the price today.",
      "Not gonna happen this round. Catch you on a sale week.",
      "Some deals aren't meant to be. Take care.",
      "I'm closing the bargaining window. The list price still loves you."
    ];

    /* pick() — picks a line from a bank without repeating within this
       conversation. Once a bank is exhausted, it resets so the next pull
       starts fresh. WeakMap keyed by the bank array, scoped to this Hoggle
       instance, so different products / re-opens get fresh state. */
    var usedLines = new Map();
    function pick(a){
      var used = usedLines.get(a);
      if (!used || used.length >= a.length) used = [];
      var pool = [];
      for (var i = 0; i < a.length; i++){
        if (used.indexOf(i) < 0) pool.push(i);
      }
      var idx = pool[Math.floor(Math.random() * pool.length)];
      used.push(idx);
      usedLines.set(a, used);
      return a[idx];
    }
    function tmpl(s, c){ return s.replace('%OFFER%', fmt(c)); }

    function addMsg(text, who, opts){
      opts = opts || {};
      var el = document.createElement('div');
      el.className = 'hoggle-msg hoggle-msg--' + who;
      var b = document.createElement('div');
      b.className = 'hoggle-msg__bubble';
      if(opts.html){ b.innerHTML = text; } else { b.textContent = text; }
      el.appendChild(b);
      thread.appendChild(el);
      thread.scrollTop = thread.scrollHeight;
      return el;
    }
    function addTyping(){
      var el = document.createElement('div');
      el.className = 'hoggle-msg hoggle-msg--bot hoggle-msg--typing';
      el.innerHTML = '<div class="hoggle-msg__bubble"><div class="hoggle-typing"><span></span><span></span><span></span></div></div>';
      thread.appendChild(el);
      thread.scrollTop = thread.scrollHeight;
      return el;
    }
    function botSay(text, cb, delay){
      working = true;
      sendBtn.disabled = true;
      var t = addTyping();
      setTimeout(function(){
        t.remove();
        addMsg(text, 'bot');
        working = false;
        sendBtn.disabled = accepted;
        if(cb) cb();
      }, delay || (700 + Math.random()*600));
    }

    function setQuickChips(chips){
      quick.innerHTML = '';
      chips.forEach(function(c){
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'hoggle-chip';
        b.textContent = c.label;
        b.addEventListener('click', function(){ submitOffer(c.cents); });
        quick.appendChild(b);
      });
    }

    function computeCounter(customerCents){
      var target = Math.round((botOfferCents + customerCents) / 2);
      var wiggle = botOfferCents - floorCents;
      var stepCap = botOfferCents - Math.round(wiggle * 0.15);
      target = Math.min(target, botOfferCents - 1);
      target = Math.max(target, stepCap);
      target = Math.max(target, floorCents);
      return target;
    }

    function handleOffer(customerCents){
      round += 1;

      /* ── LOWBALL PATH (under 50% of list) ────────────────────────────
         Track a streak. First few: regular LOWBALL banter. Past 2,
         escalate to HARD_LOWBALL (warning tone). Past 5 in a row: walk
         away. A non-lowball offer (above 50%) resets the streak — you
         can negotiate normally even after a few jokey $1 bids. */
      if(customerCents < currentCents * 0.50){
        lowballStreak += 1;
        if(lowballStreak >= maxLowballs){
          walkAwayAndShow();
          return;
        }
        if(lowballStreak >= 3){
          botSay(pick(HARD_LOWBALL));
        } else {
          botSay(pick(LOWBALL));
        }
        return;
      }

      // Real offer — reset the lowball streak.
      lowballStreak = 0;

      if(customerCents >= floorCents){
        var agreed = Math.min(botOfferCents, customerCents);
        agreed = Math.max(agreed, floorCents);
        acceptDeal(agreed);
        return;
      }

      /* Below floor but reasonable. Counter or hit floor. We do NOT
         walk away on legit offers — only on pure-lowball streaks above.
         If the customer is within 7% of floor, just accept floor;
         otherwise counter. */
      if(customerCents >= floorCents * 0.93){
        acceptDeal(floorCents);
        return;
      }

      var counter = computeCounter(customerCents);
      botOfferCents = counter;

      if(counter <= floorCents + 1){
        botSay(tmpl(pick(FLOOR_HIT), floorCents), function(){
          setQuickChips([
            { label: 'Deal at ' + fmt(floorCents), cents: floorCents },
            { label: 'Nope', cents: -1 }
          ]);
        });
        return;
      }

      var line = (customerCents < floorCents * 0.85) ? pick(TOO_LOW_SOFT) : pick(COUNTER);
      botSay(tmpl(line, counter), function(){
        setQuickChips([
          { label: 'Okay, ' + fmt(counter), cents: counter },
          { label: 'Meet halfway: ' + fmt(Math.round((counter + customerCents)/2)), cents: Math.round((counter + customerCents)/2) }
        ]);
      });
    }

    /* ── Walk-away UI ─────────────────────────────────────────────────
       Make it visually obvious Hoggle left: send the walk-away line,
       then drop in a "Hoggle has left the chat" status row, disable the
       composer, and surface a "Start over" button so the user isn't
       boxed in. */
    function walkAwayAndShow(){
      botSay(pick(WALK_AWAY), function(){
        addStatusRow();
      });
      input.disabled = true;
      sendBtn.disabled = true;
    }
    function addStatusRow(){
      var status = document.createElement('div');
      status.className = 'hoggle-status hoggle-status--walked';
      status.innerHTML =
        '<div class="hoggle-status__line">' +
          '<span class="hoggle-status__dot"></span>' +
          '<span class="hoggle-status__tx">Hoggle has left the chat</span>' +
        '</div>' +
        '<button type="button" class="hoggle-status__btn" data-hoggle-restart>Try again</button>';
      thread.appendChild(status);
      thread.scrollTop = thread.scrollHeight;
      var restart = status.querySelector('[data-hoggle-restart]');
      if(restart){
        restart.addEventListener('click', function(){ restartConversation(); });
      }
    }
    function restartConversation(){
      // Soft reset — same modal, fresh state, fresh shuffle.
      thread.innerHTML = '';
      quick.innerHTML = '';
      input.value = '';
      input.disabled = false;
      sendBtn.disabled = false;
      botOfferCents = currentCents;
      round = 0;
      lowballStreak = 0;
      accepted = false;
      working = false;
      usedLines.clear();
      botSay(pick(OPEN_LINES), function(){
        setTimeout(function(){ try{ input.focus(); }catch(e){} }, 50);
      }, 400);
    }

    function acceptDeal(agreedCents){
      accepted = true;
      input.disabled = true;
      sendBtn.disabled = true;
      quick.innerHTML = '';
      botSay(tmpl(pick(ACCEPT), agreedCents), function(){ createDiscount(agreedCents); }, 600);
    }

    function createDiscount(agreedCents){
      /* Pure-Shopify deal lock.

         The customer's "Continue to checkout" button (rendered below)
         calls Shopify's Cart API to:
           1. clear the cart,
           2. add the variant with `properties[_hoggle_agreed_cents]`,
           3. redirect to /checkout.

         A Shopify Function (Hoggle Deal Discount, deployed once) reads
         that line attribute server-side, validates the agreed price
         against the product's `custom.lowest_price` floor metafield,
         and applies a fixed-amount discount that brings the line to the
         agreed price. No external infrastructure, no discount codes,
         no codes-pool to leak.

         15-minute expiry is enforced browser-side: the Continue button
         is disabled once the timer expires, and the customer has to
         re-haggle. (Server-side enforcement of "15 min" would need a
         signed timestamp the Function could validate; we skip that
         because the worst-case abuse is "customer keeps the cart open
         for an hour and still pays floor", which is fine.) */
      var loading = addMsg(
        '<div class="hoggle-typing"><span></span><span></span><span></span></div> writing up your deal…',
        'system', { html: true }
      );
      setTimeout(function(){
        loading.remove();
        renderLockedDealCard(agreedCents);
      }, 700);
    }

    function renderLockedDealCard(agreedCents){
      var variantId = root.getAttribute('data-variant-id')
                   || root.dataset.variantId || '';
      var expiresAt = Date.now() + 15 * 60 * 1000;

      var html =
        '<div class="hoggle-deal-card hoggle-deal-card--live" data-hoggle-deal>' +
        '  <div class="hoggle-deal-card__label">Deal locked</div>' +
        '  <div class="hoggle-deal-card__price">' + fmt(agreedCents) + '</div>' +
        '  <button type="button" class="hoggle-deal-card__cta" data-hoggle-checkout>' +
        '    <span>Continue to checkout</span>' +
        '    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M5 12h14M13 5l7 7-7 7"/></svg>' +
        '  </button>' +
        '  <div class="hoggle-deal-card__timer" data-hoggle-timer>' +
        '    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>' +
        '    <span>Link expires in <strong data-hoggle-countdown>15:00</strong></span>' +
        '  </div>' +
        '  <div class="hoggle-deal-card__note">Discount auto-applies at checkout. One per customer.</div>' +
        '</div>';
      var cardEl = addMsg(html, 'bot', { html: true });

      var card = cardEl.querySelector('[data-hoggle-deal]');
      var cd = cardEl.querySelector('[data-hoggle-countdown]');
      var cta = cardEl.querySelector('[data-hoggle-checkout]');
      var timerWrap = cardEl.querySelector('[data-hoggle-timer]');
      var tickHandle;
      var expired = false;

      function setExpired(){
        if (expired) return;
        expired = true;
        if (cd) cd.textContent = 'expired';
        if (cta){
          cta.disabled = true;
          cta.classList.add('is-disabled');
          cta.querySelector('span').textContent = 'Deal expired — re-haggle to lock';
        }
        if (timerWrap) timerWrap.classList.add('is-expired');
      }
      function tick(){
        var ms = expiresAt - Date.now();
        if (ms <= 0){ setExpired(); return; }
        var m = Math.floor(ms / 60000);
        var s = Math.floor((ms % 60000) / 1000);
        if (cd) cd.textContent = m + ':' + (s < 10 ? '0' + s : s);
        if (ms < 60000 && card) card.classList.add('hoggle-deal-card--urgent');
        tickHandle = setTimeout(tick, 1000);
      }
      tick();

      // Cart-API → checkout.
      if (cta){
        cta.addEventListener('click', function(){
          if (expired || cta.disabled) return;
          if (!variantId){
            cta.querySelector('span').textContent = 'No variant id — refresh page';
            return;
          }
          cta.disabled = true;
          cta.querySelector('span').textContent = 'Sending you to checkout…';
          goToCheckoutWithDeal(variantId, agreedCents).catch(function(err){
            cta.disabled = false;
            cta.querySelector('span').textContent = 'Hmm, try once more';
            console.error('[hoggle] checkout flow failed:', err);
          });
        });
      }

      var stopOnClose = function(){
        if (tickHandle) clearTimeout(tickHandle);
        root.removeEventListener('hoggle:closed', stopOnClose);
      };
      root.addEventListener('hoggle:closed', stopOnClose);
    }

    /* Clear cart → add variant with _hoggle_agreed_cents attribute →
       redirect to /checkout. The Function on the Shopify side reads
       the attribute and applies the discount. */
    function goToCheckoutWithDeal(variantId, agreedCents){
      return fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' }
      })
        .then(function(){
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: parseInt(String(variantId).replace(/.*\//, ''), 10),
                quantity: 1,
                properties: {
                  _hoggle_agreed_cents: String(agreedCents)
                }
              }]
            })
          });
        })
        .then(function(r){
          if (!r.ok) throw new Error('cart/add failed');
          // Redirect at top level so we leave the modal behind.
          (window.top || window).location.href = '/checkout';
        });
    }

    function submitOffer(cents){
      if(working || accepted) return;
      if(cents === -1){ walkAwayAndShow(); return; }
      if(!cents || cents < 100){ return; }
      addMsg(fmt(cents), 'user');
      quick.innerHTML = '';
      input.value = '';
      handleOffer(cents);
    }

    form.addEventListener('submit', function(e){
      e.preventDefault();
      var dollars = parseFloat(input.value);
      if(isNaN(dollars) || dollars <= 0) return;
      submitOffer(Math.round(dollars * 100));
    });

    function open(){
      if(root.classList.contains('is-open')) return;
      thread.innerHTML = '';
      quick.innerHTML = '';
      input.disabled = false;
      sendBtn.disabled = false;
      input.value = '';

      /* Re-read price + obfuscated floor at open-time so per-variant
         metafields and variant-switch updates are picked up. The snippet's
         inline listener rewrites data-tx / data-current-price-cents on
         variant change. Without this re-read, hoggle.js would be stuck on
         whatever values existed at page-load. */
      currentCents = parseInt(root.dataset.currentPriceCents, 10) || currentCents;
      floorCents   = resolveFloor();
      if(floorCents <= 0 || floorCents >= currentCents){
        floorCents = currentCents;
      }
      if(listed) listed.textContent = fmt(currentCents);

      botOfferCents = currentCents;
      round = 0;
      lowballStreak = 0;
      accepted = false;
      working = false;
      // Reset per-conversation line history so a fresh open gets a fresh shuffle.
      usedLines.clear();
      root.classList.add('is-open');
      root.setAttribute('aria-hidden','false');
      document.body.style.overflow = 'hidden';
      // No haggle room on this product? Open with a polite brush-off.
      if(floorCents >= currentCents){
        accepted = true;
        botSay("Sorry, this one's already at our best price — no wiggle today. Check back on another item.", function(){
          input.disabled = true;
          sendBtn.disabled = true;
        }, 500);
        return;
      }
      botSay(pick(OPEN_LINES), function(){
        setTimeout(function(){ try{ input.focus(); }catch(e){} }, 50);
      }, 500);
    }
    function close(){
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden','true');
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-hoggle]').forEach(function(btn){
      if(btn.dataset.hoggleBound === '1') return;
      btn.dataset.hoggleBound = '1';
      btn.addEventListener('click', open);
    });
    root.querySelectorAll('[data-hoggle-close]').forEach(function(x){ x.addEventListener('click', close); });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && root.classList.contains('is-open')) close();
    });
  }

  function boot(){
    document.querySelectorAll('[data-hoggle-root]').forEach(init);
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();